module.exports = __webpack_public_path__ + "5f101204c48aacf2fe8ee01d0e8aeded.svg";